module.exports = __webpack_public_path__ + "img/trivia-success-player.71c81d02.svg";